import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-195">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-charcoal-900/90 backdrop-blur-sm" onClick={onClose} data-id="element-196" />

      {/* Modal */}
      <div className="relative bg-charcoal-800 border border-charcoal-700 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-197">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-charcoal-700" data-id="element-198">
          <h2 className="text-xl font-serif text-cream-100" data-id="element-199">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-charcoal-700 transition-colors text-cream-200/60 hover:text-cream-100" data-id="element-200">
            <X className="w-5 h-5" data-id="element-201" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-cream-200/80 text-sm leading-relaxed" data-id="element-202">
          {children}
        </div>
      </div>
    </div>;
}